
import Base from '../base';
import config from './config';

const CLASS_IS_ACCEPTED = 'is-accepted';

class CookieNotification extends Base {
	start() {
		const value = config.get(this.options);

		if (value) {
			return;
		}

		this.show();
		this.on('submit');
	}

	show() {
		this.el.classList.remove('is-hidden');
	}

	onSubmit(e) {
		e.preventDefault();

		this.setCookie();
		this.remove();
	}

	onAnimationend() {
		this.destroy();
	}

	setCookie() {
		config.set(this.options, 'true');
	}

	remove() {
		// element uses an animation to appear, so this listener
		// should not be added earlier
		this.on('animationend');

		this.el.classList.add(CLASS_IS_ACCEPTED);
	}

	destroy() {
		this.off('submit');
		this.off('animationend');

		this.el.parentNode.removeChild(this.el);
	}
}

export default CookieNotification;
